<template>
  <div class="content asset-card-list">
    <section style="margin-bottom: 1%">
      <a-button type="primary" @click="createHandle">
        <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
        {{ $t('新增资产卡片') }}
      </a-button>
    </section>
    <div class="form-content">
      <a-row :gutter="16" style="margin-top: 15px">
        <a-col :span="6">
          <CommonSelect
            :isBu="true"
            mode="multiple"
            :placeholder="$t('结算组织')"
            :list="$store.state.settlementBuList"
            :code.sync="formData.ownerBusinessUnitCodeList"
            @change="searchHandle(1)"
          />
        </a-col>
        <a-col :span="6">
          <a-input
            allow-clear
            v-model.trim="formData.cardNo"
            :placeholder="$t('卡片编号')"
            @keydown.enter="searchHandle(1)"
          />
        </a-col>
        <a-col :span="6">
          <DateRangePicker
            :needhms="false"
            @get_date="chooseStartUseDate"
            :placeholder="$t('开始使用日期')"
            :start-time="startUseDateRange[0]"
            :end-time="startUseDateRange[1]"
          />
        </a-col>
        <a-col :span="6">
          <a-select
            v-model="formData.needGenerateVoucher"
            allow-clear
            :placeholder="$t('能否生成凭证')"
            style="width: 100%"
          >
            <a-select-option :value="1">{{ $t('需要') }}</a-select-option>
            <a-select-option :value="0">{{ $t('不需要') }}</a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-row :gutter="16" style="margin-top: 10px">
        <a-col :span="6">
          <a-select
            v-model="formData.voucherGenerated"
            allow-clear
            :placeholder="$t('已生成凭证')"
            style="width: 100%"
          >
            <a-select-option :value="1">{{ $t('是') }}</a-select-option>
            <a-select-option :value="0">{{ $t('否') }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6">
          <a-button @click="searchHandle(1)" type="primary">
            <i class="iconfont" style="margin-right: 5px">&#xe647;</i>
            {{ $t(`查询`) }}
          </a-button>
          <a-button @click="reset">
            <a-icon type="redo" />
            {{ $t(`重置`) }}
          </a-button>
        </a-col>
      </a-row>
    </div>
    <CommonTable
      ref="CommonTableRef"
      :statusList="$store.state.asset_card_status"
      :columns.sync="columns"
      :loading="loading"
      :dataSource="tableData"
      :showSelect="true"
      :scroll="{ x: 1500 }"
      :selectedRowKeys.sync="selectedRowKeys"
      :selectedRows.sync="selectedRows"
      :total="total"
      rowKey="id"
      @select="onSelectChange"
      @search="getList"
    >
      <template v-slot:header>
        <div class="flex-ct">
          <OperateBtn
            api="operateAssetCard"
            :text="$t('审核')"
            :params="{
              action: 'CHECK',
              idList: selectedRowKeys,
            }"
            :disabled="selectedRows.length === 0"
            @success="searchHandle"
          />
          <VoucherBtn
            class="ml10"
            :docType="docType"
            :selectedRows="selectedRows"
            :disabled="selectedRows.length === 0"
            @close="searchHandle"
          />
        </div>
      </template>
      <template v-slot:assetCode="{ text, record }">
        <a @click="viewDetail(record)">{{ text }}</a>
      </template>
    </CommonTable>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import CommonTable from '@/component/commonTable'
import DateRangePicker from '@/component/dateRangePicker'
import { convertKeysToCamelCase } from '@/common'
import dayjs from 'dayjs'
export default {
  name: 'assetCardList',
  components: { CommonTable, DateRangePicker },
  data() {
    return {
      docType: 'AssetCard',
      formData: {
        ownerBusinessUnitCodeList: [],
        cardNo: undefined,
        startUseDate: undefined,
        startUseBeforeDate: undefined,
        needGenerateVoucher: undefined,
        voucherGenerated: undefined,
      },
      startUseDateRange: [],
      tableData: [],
      selectedRowKeys: [],
      selectedRows: [],
      total: 0,
      loading: false,

      columns: [
        {
          title: this.$t('卡片编号'),
          dataIndex: 'assetCode',
          width: 220,
          scopedSlots: { customRender: 'assetCode' },
        },
        {
          title: this.$t('结算组织'),
          dataIndex: 'ownerBusinessUnitName',
          width: 120,
        },
        {
          title: this.$t('资产组织'),
          dataIndex: 'userBusinessUnitName',
          width: 120,
        },
        {
          title: this.$t('资产类别'),
          dataIndex: 'assetTypeName',
          width: 120,
        },
        // {
        //   title: this.$t('卡片编号'),
        //   dataIndex: 'cardNo',
        //   width: 200,
        // },
        {
          title: this.$t('资产名称'),
          dataIndex: 'assetName',
          width: 180,
        },
        {
          title: this.$t('开始使用日期'),
          dataIndex: 'startUseDate',
          customRender: (text) => text?.split(' ')?.[0],
          width: 140,
        },
        {
          title: this.$t('数量'),
          dataIndex: 'quantity',
          width: 100,
        },
        {
          title: this.$t('计量单位'),
          dataIndex: 'unitName',
          width: 100,
        },
        {
          title: this.$t('单据状态'),
          dataIndex: 'status',
          width: 120,
          customRender: (text) => this.$store.getters.assetCardStatusMapping[text],
        },
        {
          title: this.$t('能否生成凭证'),
          dataIndex: 'needGenerateVoucher',
          width: 100,
          customRender: (text, record) => {
            const val = record.needGenerateVoucher ?? record.need_generate_voucher
            return val === 1 ? this.$t('需要') : val === 0 ? this.$t('不需要') : ''
          },
        },
        {
          title: this.$t('是否生成凭证'),
          dataIndex: 'voucherGenerated',
          width: 100,
          customRender: (text) => (text ? this.$t('是') : this.$t('否')),
        },
        {
          title: this.$t('凭证号'),
          dataIndex: 'voucherNo',
          width: 140,
        },
      ],
    }
  },
  activated() {
    this.searchHandle()
  },
  methods: {
    ...mapMutations(['addPane']),
    chooseStartUseDate(date) {
      if (date && date.start_time && date.end_time) {
        this.formData.startUseDate = dayjs(date.start_time).format('YYYY-MM-DD')
        this.formData.startUseBeforeDate = dayjs(date.end_time).add(1, 'day').format('YYYY-MM-DD')
        this.startUseDateRange = [date.start_time, date.end_time]
      } else {
        this.formData.startUseDate = undefined
        this.formData.startUseBeforeDate = undefined
        this.startUseDateRange = []
      }
    },
    reset() {
      this.startUseDateRange = []
      Object.assign(this.$data, this.$options.data.call(this))
      this.searchHandle(1)
    },
    searchHandle(pageNo) {
      this.selectedRows = []
      this.selectedRowKeys = []
      this.$refs.CommonTableRef.queryList(pageNo)
    },
    createHandle() {
      this.$router.push({ name: 'assetCardDetail' })
    },
    async getList(params) {
      this.loading = true
      const data = {
        ...this.formData,
        ...params,
      }
      if (params.status) {
        data.statusList = [params.status]
      }
      await http({
        url: api.getAssetCardList,
        data,
        success: (res) => {
          let result = convertKeysToCamelCase(res.result)
          this.tableData = result.list
          this.total = res.result.total
        },
      })
      this.loading = false
    },
    viewDetail(record) {
      this.addPane({
        view: 'asset/assetCardDetail/' + record.assetCode,
        name: 'detailSn',
        query: {
          id: record.id,
          sn: record.assetCode,
        },
        route: `/asset/assetCardDetail?id=${record.id}&sn=${record.assetCode}`,
      })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
  },
}
</script>
